export function data() {
  return {
    isDebug: true,
    isOpen: false,
    loading: true,
    openOnFocus: true,
    boardList: [],
    committeeID: null,
    toggleBoard: false
  }
}
